import {
  GET_KNOWLEDGE_POSTS,
  GET_ACTIVE_USERS,
  GET_POPOLAR_POST,
  UPDATE_KNOWLEDGE_POST,
  GET_DETAIL_POST,
  GET_OTHER_POST,
  GET_PROFILE_ACTIVITY,
  GET_PROFILE_ARTICLE,
  GET_PROFILE_ID,
  GET_LIST_CATEGORY,
  GET_LIST_COMPETENCE,
  ADD_COMMENT_POST,
  RESET_DETAIL_POST,
  GET_LIST_LIKED_POST,
  GET_LIST_VIEWED_POST,
  UPDATE_LIKED_POST_IN_DETAIL,
  UPDATE_LIST_POST_BY_ID,
  DELETE_KATEGORI,
  DELETE_KOMPETENSI,
  GET_UNITKERJA,
  GET_SATKERBYUNKER,
  SET_FILTERSEARCH
} from 'shared/constants/ActionTypes';

const linimasa = {
  count: null,
  next: null,
  previous: null,
  results: []
}

const linimasapop = {
  count: null,
  next: null,
  previous: null,
  results: []
};

const linimasaactiveuser = {
  message: null,
  results: [],
  success: false
};

const linimasadetail = {
  success: false,
  message: null,
  results: {}
};

const linimasaotherpost = {
  count: null,
  next: null,
  previous: null,
  results: []
};

const profileid = {
  success: false,
  message: null,
  results: {}
};

const profileArticle = {
  count: null,
  next: null,
  previous: null,
  results: []
};

const profileActivity = {
  count: null,
  next: null,
  previous: null,
  results: []
};

const setFilterSearch = {
  search: '',
  unker: '',
  satker: '',
  category: [],
  competence: [],
  idUnker: '',
  dataCategory:[],
  dataCompetence:[]
}

const initialState = {
  kmList: linimasa,
  kmListPop: linimasapop,
  kmActiveUsers: linimasaactiveuser,
  kmData: null,
  kmDetail: linimasadetail,
  kmOtherPost: linimasaotherpost,
  profileid: profileid,
  profileActivity: profileActivity,
  profileArticle: profileArticle,
  listCategory: [],
  listCompetence: [],
  listUnker:[],
  listSatkerByUnker:[],
  addcomment: null,
  listLiked: null,
  listViewed: null,
  setFilterSearch:setFilterSearch
};

const kmReducer = (state = initialState, action) => {
  switch (action.type) {

    case GET_KNOWLEDGE_POSTS: {
      if (action.payload.isReload) {
        return { ...state, kmList: action.payload.data }
      } else {
        return {
          ...state,
          kmList: {
            ...action.payload.data,
            results: [...state.kmList.results, ...action.payload.data.results]
          }
        };
      }
    }
    case GET_ACTIVE_USERS: {
      return { ...state, kmActiveUsers: action.payload };
    }
    case GET_POPOLAR_POST: {
      return { ...state, kmListPop: action.payload }
    }
    case UPDATE_KNOWLEDGE_POST: {
      return { ...state }
    }
    case GET_DETAIL_POST: {
      return { ...state, kmDetail: action.payload }
    }
    case GET_OTHER_POST: {
      return { ...state, kmOtherPost: action.payload }
    }
    case GET_PROFILE_ACTIVITY: {
      return { ...state, profileActivity: action.payload }
    }
    case GET_PROFILE_ID: {
      return { ...state, profileid: action.payload }
    }
    case GET_PROFILE_ARTICLE: {
      return { ...state, profileArticle: action.payload }
    }
    case GET_LIST_CATEGORY: {
      return { ...state, listCategory: action.payload }
    }
    case GET_LIST_COMPETENCE: {
      return { ...state, listCompetence: action.payload }
    }
    case GET_UNITKERJA: {
      return { ...state, listUnker: action.payload }
    }
    case GET_SATKERBYUNKER: {
      return { ...state, listSatkerByUnker: action.payload }
    }
    case ADD_COMMENT_POST: {
      return {
        ...state,
        // addcomment: action.payload,
        kmDetail: {
          ...state.kmDetail,
          result: {...action.payload}
        }
      }
    }
    case UPDATE_LIKED_POST_IN_DETAIL: {
      return {
        ...state,
        // addcomment: action.payload,
        kmDetail: {
          ...state.kmDetail,
          result: {...action.payload}
        }
      }
    } 
    case UPDATE_LIST_POST_BY_ID: {
      for(let i = 0; i<state.kmList.results.length; i++){
        if(state.kmList.results[i].id == action.payload.id){
          state.kmList.results[i].comment_count = action.payload.comment_count;
          state.kmList.results[i].likes_count = action.payload.likes_count;
          state.kmList.results[i].views_count = action.payload.views_count;
          state.kmList.results[i].liked = action.payload.liked;
          break;
        }
      }
      return {
        ...state
      }
    } 
    case RESET_DETAIL_POST: {
      return { ...state, kmDetail: linimasadetail }
    }
    case GET_LIST_VIEWED_POST: {
      return { ...state, listViewed: action.payload }
    }
    case GET_LIST_LIKED_POST: {
      return { ...state, listLiked: action.payload }
    }
    case DELETE_KATEGORI: {
      return { ...state, listCategory: [] }
    }
    case DELETE_KOMPETENSI: {
      return { ...state, listCompetence: [] }
    }
    case SET_FILTERSEARCH: {
      return { ...state, setFilterSearch: action.payload }
    }
    default: {
      return state;
    }
  }
};
export default kmReducer;
